import React from "react";

/**
 * Renders a tag element inside the FilterSelect
 * @param {*} props
 */
const FilterSelectTag = (props) => (
  <div className="filter-select-input-multivalue">
    <div className="filter-select-input-tag-value">{props.label}</div>
    <div className="filter-select-input-tag-close" onClick={props.onClick} />
  </div>
);
export default FilterSelectTag;
